import { MenuItem } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../../common/ChameleonElement';
export class NavigationDrawerItemComponent extends ChameleonElementMixin(MenuItem) {
    constructor() {
        super(...arguments);
        this.handleHostClick = (e) => {
            if (this.hasAttribute('disabled')) {
                e.stopImmediatePropagation();
            }
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('click', this.handleHostClick);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('click', this.handleHostClick);
    }
}
